export const REQUEST_MESSAGES_COUNTER = '@DASHBOARD/REQUEST_MESSAGES_COUNTER'
export const REQUEST_MESSAGES_RANGE = '@DASHBOARD/REQUEST_MESSAGES_RANGE'
export const SET_MESSAGES_COUNTER = '@DASHBOARD/SET_MESSAGES_COUNTER'
export const SET_MESSAGES_RANGE = '@DASHBOARD/SET_MESSAGES_RANGE'

export const REQUEST_USERS_COUNTER = '@DASHBOARD/REQUEST_USERS_COUNTER'
export const REQUEST_USERS_RANGE = '@DASHBOARD/REQUEST_USERS_RANGE'
export const SET_USERS_COUNTER = '@DASHBOARD/SET_USERS_COUNTER'
export const SET_USERS_RANGE = '@DASHBOARD/SET_USERS_RANGE'

export const REQUEST_CONNECTIONS_COUNTER = '@DASHBOARD/REQUEST_CONNECTIONS_COUNTER'
export const REQUEST_CONNECTIONS_RANGE = '@DASHBOARD/REQUEST_CONNECTIONS_RANGE'
export const SET_CONNECTIONS_COUNTER = '@DASHBOARD/SET_CONNECTIONS_COUNTER'
export const SET_CONNECTIONS_RANGE = '@DASHBOARD/SET_CONNECTIONS_RANGE'
